import type { Nullable } from '@iheartjane/types';
import type { PropsWithChildren } from 'react';
import { createContext, useMemo, useState } from 'react';

import type { Cart, EmptyCart } from '@jane/shared/types';

import { useEnsureContextWithinProvider } from './hooks/useEnsureContextWithinProvider';

type CartInfo = Nullable<{
  birthDate?: Nullable<string>;
  cart: Cart | EmptyCart;
  phoneNumber: Nullable<string>;
  selectedBankAccount: Nullable<string>;
  signedInOrder: boolean;
}>;

interface CartInfoForTrackingContext {
  cartInfo: CartInfo;
  setCartInfo: (cartInfo: CartInfo) => void;
}

const CartInfoForTrackingContext =
  createContext<CartInfoForTrackingContext | null>(null);

export const CartInfoForTrackingProvider = ({
  children,
}: PropsWithChildren) => {
  const [cartInfo, setCartInfo] = useState<CartInfo>(null);
  const cartInfoContext = useMemo(
    () => ({ cartInfo, setCartInfo }),
    [cartInfo, setCartInfo]
  );
  return (
    <CartInfoForTrackingContext.Provider value={cartInfoContext}>
      {children}
    </CartInfoForTrackingContext.Provider>
  );
};

export const useCartInfoForTracking = () =>
  useEnsureContextWithinProvider(
    CartInfoForTrackingContext,
    'CartInfoForTracking'
  );
